export default __webpack_public_path__ + "static/media/Cherry Ripe Dessert - proportioned_170.abcf5a92.jpg";